import { Component, OnInit,Input, ElementRef } from '@angular/core';
import {ScaleResult} from '../../shared/models/scale-result';
import * as Chart from 'chart.js';
import {ChartService} from "../services/chart.service";
import { ScaleResultColorService } from 'app/assessment-charts/services/scale-result-color.service';
import { ScaleRange } from 'app/shared/models/scale-range';
import { BaseChartComponent } from 'app/assessment-charts/base-chart/base-chart.component';

@Component({
  selector: 'app-summary-scales-chart',
  templateUrl: './summary-scales-chart.component.html',
  styleUrls: ['./summary-scales-chart.component.css']
})
export class SummaryScalesChartComponent extends BaseChartComponent implements OnInit {

  private MAX_SCALE_NAME_LENGTH:number = 75;
  @Input("scaleResults") scaleResults:ScaleResult[];
  @Input("showNames") showNames:Boolean;
  @Input("showRangeScore") showRangeScore:Boolean;
  @Input("chartScaleNames") chartScaleNames:string[];
  @Input("chartRangeNames") chartRangeNames:string[];

  /**
   * Should the graph have the top yAxis label be a positive color/value instead
   * of a negative.  if reverseDirection is set to true, all of the scale range labels
   * are reversed with their corresponding colors.
   */
  @Input("reverseDirection") reverseDirection:boolean;
  private _labelData:any[];
  private _barData:any;
 
  constructor(private element:ElementRef, private chartService:ChartService
    , private scaleResultColorService:ScaleResultColorService) {
      super(element, chartService);
      this.reverseDirection = false;
    }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  private getAdjustedFontSize(fontSize) {
    let adjustment = fontSize / 14.4;
    let vpFontSize = this.getFontSizeForCurrentViewport();
    return fontSize * adjustment;
  }

  private getFontSizeForCurrentViewport() {
    let fontSize = 14.4;
    let mediumDevice = window.matchMedia('(max-width: 768px)');
    let smallDevice = window.matchMedia('(max-width: 450px');
    if (mediumDevice) {
      fontSize = 12.0;
    }
    else if (smallDevice) {
      fontSize = 10.0;
    }
    return fontSize;
  }
  protected setupChartConfiguration() {
    let fontSize = this.getFontSizeForCurrentViewport();
    let configuration = super.setupChartConfiguration();
    configuration.legend = {
      display: false
    };
    configuration.tooltips = {
      enabled: false
    };
    /*
    title: {
        display: false
        ,text: "some title goes here"
      }
      */
    // configuration.title = {
    //   display: true
    //   ,position: 'top'
    //   ,text: 'Severity: Slightly Elevated'
    //   ,fontSize: this.getAdjustedFontSize(18)
    // };
    let xAxes = configuration.scales.xAxes[0];
    xAxes.id = 'first-x-axis';
    xAxes.ticks = {
      beginAtZero: true
      ,autoSkip: false
    };
    xAxes.gridLines = {
      offsetGridLines: true
    };
    xAxes.offset = true;
    configuration.scales.xAxes.push({
      id: 'second-x-axis'
      ,display: false
    });
    // configuration.scales.xAxes[0].display = false;

    // these should all be the same length so grab the first one.
    let yMax = this.scaleResults[0].scale.ranges.length;

    let yAxes = configuration.scales.yAxes[0];
    yAxes.id = 'first-y-axis';
    yAxes.type = 'linear';
    yAxes.ticks = {
      stepSize: 1
      ,callback: (value, index, values) => {
        let scaleRangeNames = this.getChartRangeNames();
        // if (value == 0 || !scaleRangeNames.hasOwnProperty(value-1)) {
        //   return " ";
        // }
        // else {
          return scaleRangeNames[value-1];
        // }
      }
      ,beginAtZero: true
      ,max: yMax
      ,fontSize: fontSize
    };
    configuration.defaultFontSize = fontSize;
    // yAxes.padding = 0;
    // yAxes.fontSize = 10;
    yAxes.position = 'left';
    
    if (this.scaleResults.length < 3) {
      configuration.scales.xAxes[0].barPercentage = 0.50;
      configuration.scales.xAxes[0].maxBarThickness = 50;
    }
    else if (this.scaleResults.length < 5) {
      configuration.scales.xAxes[0].maxBarThickness = 50;
    }

    configuration.elements =  { 
        point: { 
          radius: 0 // should hide the points from displaying...
          ,hoverRadius: 0
        } 
      };
    configuration.scales.xAxes[0].display = this.showNames === true;
    configuration.layout.padding = {
      right: 10
      ,top: 10
      ,bottom: 10
    }
    return configuration;
  }
  protected getLabelData() {
    return this._labelData;
  }
  protected getDatasets() {
    return this._barData;
  }

  private getLabelsForScales(results:ScaleResult[]) {
    let labels =  this.scaleResults.map(sr => sr.scale.name.substring(0, Math.min(sr.scale.name.length, this.MAX_SCALE_NAME_LENGTH)));
    // let labels =  this.scaleResults.map(sr => sr.scale.name);
    if (this.chartScaleNames) {
      if (this.chartScaleNames.length != results.length) {
        console.error("chart scale names",this.chartScaleNames, " do not match number of scales ", results);
      }
      else {
        labels = this.chartScaleNames;
      }
    }
    // make sure we have two empty labels at the beginning and end of the graph
    // we do this because of the grid offset setting, otherwise the bar graphs would have
    // a bar at the front and end that are cut in half making the graph pretty ugly.
    // labels.unshift("");
    // labels.push("");
    return labels;
  }

  protected getChartRangeNames() {
    let scaleRangeNames = this.chartRangeNames;
    if (!scaleRangeNames || scaleRangeNames.length == 0) {
      scaleRangeNames = this.scaleResults[0].scale.ranges.map(r => {
        let name = r.displayName || "";
        if (this.showRangeScore !== false) {
          name += " (" + r.rangeEnd + ")";
        }
        else {
          console.log("showRangeScore was false for ", this.scaleResults[0]);
        }
        return name;
      });
    }
    else if (scaleRangeNames.length != this.scaleResults[0].scale.ranges.length) {
      console.error("Scale range names does not match count of scale ranges");
    }
    else {
      scaleRangeNames = scaleRangeNames.map((v, i) => {
        let range = this.scaleResults[0].scale.ranges[i];
        return v + " (" + range.rangeEnd + ")";
      });
    }
    return scaleRangeNames;
  }
  protected setupChartData() {
    let barColor = "#007FFF";
    let hoverBackgroundColor = "rgba(92,141,181, .75)";
    let borderColor: "rgba(0, 0, 0, 1)";

    if (this.scaleResults) {

      let dataSets = [];
      let barGraphData = []; // to offset the bar graph by one


      // ranges where we don't have scales have to have a score range of 0...
      // need to make this just work... assume there are 5 scales...
      // scalePerc = (score > range ? rangeEnd % : score % of range)
      // 1 scale -> (score % of range), 0, 0, 0, 0
      // 2 scale -> scalePerc, 0, 0, 0, scalePerc
      // 3 scale -> scalePerc, 0, scalePerc, 0, scalePerc
      // 4 scale -> scalePerc, scalePerc, 0, scalePerc, scalePerc
      // 5 scale -> scalePerc, scalePerc, scalePerc, scalePerc, scalePerc

      // this.scaleResults.map(sr => sr.scale.ranges)
      // .reduce((prev, next) => prev = prev.concat(next), [])
      // .forEach(r => console.log(r.name, "(",r.rangeStart, "-",r.rangeEnd, ")"));

      this.scaleResults.forEach(sr => {
        // TODO: stephen later we want to generate an aproximate range modifier here...
        let index = sr.scale.ranges.indexOf(sr.range);
        // TODO: stephen much of this code is leftover from various graphing mechanisms we had before as each of the scales
        // is on an ordinal value, but we represent the percentage through decimal numbers here.
        let scorePercent = sr.range.getPercentageForRange(sr.score) / 100; // from 0 -> 1 this will increase the graph percent that way.
        if (scorePercent <= 0) {
          // we need to show something on the graph so let's do a .10 percent increment here so we can see some kind of bar here.
          scorePercent += .10;
        }

        // let index = sr.scale.ranges.indexOf(sr.range) + .5;
        barGraphData.push(index + scorePercent);
      });
      // barGraphData.push(0);  // to provide the padding offset at the end.
      dataSets.push({
        label: "data"
        ,backgroundColor: barColor
        ,borderColor: "rgba(0, 0, 0, 1)"
        ,borderWidth: 1
        ,yAxisID: 'first-y-axis'
        ,data: barGraphData
      });

      let scaleRangeNames = this.getChartRangeNames();

      let scaleRanges = this.scaleResults[0].scale.ranges;
      let colors = this.scaleResultColorService.getBackgroundColors(scaleRangeNames.length);
      if (this.reverseDirection) {
        colors.reverse();
      }
      colors.forEach((colorChart, index) => {
        dataSets.push({
          label: scaleRangeNames[index]
          ,data: Array(this.scaleResults.length+1).fill(index+1)
          ,backgroundColor: colorChart.color
          ,borderColor: colorChart.color
          // ,borderWidth: 0
          ,pointRadius: 0
          ,type: 'line'
          ,xAxisID: 'second-x-axis'
          ,yAxisID: 'first-y-axis'
        });
      });
      this._barData = dataSets;

      this._labelData = this.getLabelsForScales(this.scaleResults);
    }
    else {
      this._barData = {datasets: [], label: []};
    }
  }

  public get hasResults() {
    return this.scaleResults != null && this.scaleResults.length;
  }
}



// WEBPACK FOOTER //
// ./src/app/assessment-charts/summary-scales-chart/summary-scales-chart.component.ts